<template>
  <div>
    <header>
      <div class="type-area nav-list">
        <a class="nav-l" href="/">
          <!-- <img :src="imgUrl + 'img/pc/logo.png'" alt="" /> -->
          <img :src="imgUrl + 'img/pc/logo-title.png'" alt="" />
        </a>
        <div class="nav-r">
          <router-link to="/" :class="{'nav-active': path === '/'}"
            >首页</router-link
          >
          <!-- <a href="https://www.ldmnq.com/forum/forum-41-1.html?type=lastest"
                       target="_blank">官网论坛</a> -->
          <!-- <router-link to="/about" :class="{'nav-active': path === '/about'}"
            >关于我们</router-link
          > -->
          <!-- <router-link
            to="/product"
            :class="{ 'nav-active': path === '/product' }"
            >产品介绍</router-link
          > -->
        </div>
      </div>
    </header>
  </div>
</template>
<script>
export default {
  name: "HeaderNav",
  data() {
    return {
      navList: [
        {
          path: "/",
          value: "首页",
        },
        {
          path: "https://www.ldmnq.com",
          value: "模拟器",
        },
        {
          path: "c",
          value: "关于我们",
        },
      ],
      path: "",
      imgUrl: "https://res.ldmnq.com/ldq_website/",
    };
  },
  created() {
    this.init();
  },
  methods: {
    /**
     * 初始化
     */
    init() {
      this.path = this.$route.path;
    },
  },
};
</script>
<style lang="scss" scoped>
header {
  width: 100%;
  // min-width: 1200px;
  height: changeVw(100);
  background: rgba(0, 0, 0, 1);
  // background: #000000;
  // opacity: 0.4;
  margin: 0 auto;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
}
.nav-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  .nav-l {
    display: flex;
    align-items: center;
    // img:first-child {
    //   margin-right: changeVw(16);
    //   width: changeVw(60);
    //   height: changeVw(60);
    // }
    img:nth-child(1) {
      width: changeVw(182);
      // height: changeVw(52);
    }
  }
  .nav-r {
    font-size: changeVw(14);
    a {
      margin-right: changeVw(40);
      color: #fff;
    }
    .nav-active {
      color: #ffcc00;
    }
  }
}
</style>
